export default __webpack_public_path__ + "static/media/04_motor_Politica.f448ae28.svg";